export default "__VITE_ASSET__a_i0Ylua__"